import { Snackbar } from "@material-ui/core";
import MuiAlert from '@material-ui/lab/Alert';
import { useDispatch, useSelector } from 'react-redux';

import {
    removeAlert
} from '../../redux/actions';


export default function Alerts() {

    // get alerts from redux
    const alerts = useSelector((state: any) => state.alerts);

    const dispatch = useDispatch();

    if (!alerts.length) { return null; }

    return <Snackbar
        open={true}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "calc(1rem / 2)" }}>
            {
                alerts?.map((alert: any) => {
                    return <MuiAlert
                        key={alert.id}
                        elevation={6}
                        variant="filled"
                        severity={alert.severity}
                        onClick={() => { dispatch(removeAlert(alert.id)) }} >
                        {alert.message}
                    </MuiAlert>
                })
            }
        </div>
    </Snackbar>
}


